import { useQuery } from "@apollo/client";
import { GET_ONLINE_BOOK_BY_ID } from "../Schema/OnlineBook";

const useGetOnlineBookById = ({ id }) => {
  const { data, loading, error, refetch } = useQuery(GET_ONLINE_BOOK_BY_ID, {
    variables: { id },
    skip: !id,
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    onError: (err) => {
      console.error("Error fetching online book:", err.message);
    },
  });

  return {
    bookData: data?.getOnlineBookById ?? null,
    loading,
    error,
    refetch,
  };
};

export default useGetOnlineBookById;
